import * as z from 'zod';

import { CompanyId, RecurringCompanyReportId, SftpSiteId, UserId } from './BrandedIds';
import { CompanyReport, CompanyReportFilters, CompanyReportType, ReportFormat } from './CompanyReport';
import { HourWhole, Timezone } from './Time';
import { EmailString } from './validations/email';

export const RecurringCompanyReportFilters = CompanyReportFilters.partial();

export type RecurringCompanyReportFilters = z.infer<typeof RecurringCompanyReportFilters>;

export enum RecurringReportFrequency {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
}

export const RecurringCompanyReport = z.object({
  id: RecurringCompanyReportId,
  type: z.nativeEnum(CompanyReportType),
  title: z.string(),
  userId: UserId,
  companyId: CompanyId,

  emails: z.array(EmailString).optional(),
  sftpSiteId: SftpSiteId.optional(),
  deliveryHour: HourWhole,
  deliveryTimeZone: Timezone,

  filters: RecurringCompanyReportFilters.optional(),
  reportingDaysDelta: z.number().int().optional(),

  format: ReportFormat.optional(),

  rruleDeliveryDates: z.string(),
  nextReportDeliveryDate: z.date().optional(),
  nextReportToDate: z.string().optional(),
  nextReportFromDate: z.string().optional(),
  endDate: z.date().optional(),

  createdAt: z.date(),
  updatedAt: z.date(),
});

export type RecurringCompanyReport = z.infer<typeof RecurringCompanyReport> & { latestReport?: CompanyReport };
